/**
 * components/filters/UnitFilter.js — Бүтцийн нэгжийн шүүлт (Цех + Хэсэг).
 *
 * Орж ирсэн хэрэглэгчийн ЭРХЭЭР бүтцийн нэгжийг харуулна — доторх
 * DepartmentTseh нь admin (sso_owner) бол бүх цех, бусад тохиолдолд өөрийн
 * эрхийн хүрээний нэгжүүдийг л жагсаана. DepartmentNegj нь сонгосон цехийн
 * доторх хэсгүүдийг харуулна.
 *
 * Props:
 *   deptCode, deptParentId, sectionCode        — сонгогдсон утгууд
 *   onDeptChange(code, parentId, name)         — цех солигдоход
 *   onSectionChange(code, name)                — хэсэг солигдоход
 *   autoSelectOwn                              — цех БА хэсэг хоёуланд
 *                                                (default false — жагсаалтад
 *                                                 хэсгээ бүхэлд нь харах)
 *   autoSelectDept / autoSelectSection         — ТУС ТУСАД нь дарж бичих.
 *                                                Өгөөгүй бол `autoSelectOwn`.
 *   truncateLength                             — DepartmentNegj-ийн кодыг N
 *                                                оронгоор тасдах (жш: 4)
 *   deptStyle, sectionStyle                    — wrapper style override
 *   disabled / disabledSection                 — түгжих (бүхэлд / хэсэг л)
 *
 * ⚠ ЯАГААД ЦЕХ/ХЭСГИЙГ ТУСАД НЬ УДИРДАХ ХЭРЭГТЭЙ ВЭ:
 *   Дата анализ мэтийн хуудсанд «өөрийн ЦЕХ анхдагчаар сонгогдсон, гэхдээ
 *   ХЭСЭГ нь Бүгд» гэсэн хослол хэрэгтэй — тэгж байж цехийн бүхэл зураг
 *   гарна. Өмнө нь ганц `autoSelectOwn` байсан тул хоёулаа зэрэг асаж/унтарч,
 *   дунд нь тааруулах боломжгүй байв. Үүний улмаас БҮХ ЦЕХИЙГ ХАРАХ эрхтэй
 *   хэрэглэгч (sso_owner, ХАБЭА хэлтэс) хуудас нээхэд цех нь ХООСОН ирдэг
 *   байсан — энгийн хэрэглэгчид харин сонгогдчихдог тул анзаарагдахгүй.
 */
import React from "react";
import DepartmentTseh from "src/components/departmentTseh";
import DepartmentNegj from "src/components/departmentNegj";

export default function UnitFilter({
  deptCode,
  deptParentId,
  sectionCode,
  onDeptChange,
  onSectionChange,
  autoSelectOwn = false,
  autoSelectDept,
  autoSelectSection,
  truncateLength,
  deptStyle,
  sectionStyle,
  // Засварлах боломжгүй (үзэх горим) эсвэл эрхээр ТҮГЖИГДСЭН үед.
  // `disabledSection` нь ЗӨВХӨН хэсгийг түгжинэ (цех нь чөлөөтэй).
  disabled = false,
  disabledSection,
}) {
  /* ⚠ ЦЕХИЙГ ХООСОЛСОН ЭСЭХ (2026-10-05): доорх DepartmentNegj нь
     `key`-ээр ДАХИН УГСРАГДДАГ тул «цех хоосорлоо» гэдгийг өөрөө мэдэхгүй —
     шинэ мөчлөгт `autoSelectOwn` дахин ажиллаж ӨӨРИЙН хэсгийг сонгоод
     тавьдаг. Үр дүнд хэрэглэгч цехийг «Бүгд» болгосон ч хэсэг хоосрохгүй,
     жагсаалт нэг хэсгээр шүүгдсэн хэвээр үлддэг. */
  const [deptCleared, setDeptCleared] = React.useState(false);
  const sectionAuto =
    autoSelectSection === undefined ? autoSelectOwn : autoSelectSection;
  return (
    <>
      {/* Цех — эрхийн хүрээнд.
          Responsive: minWidth-ээр хатуу барихын оронд flex-basis — өргөн
          дэлгэцэд байгалийн хэмжээтэй, нарийн дэлгэцэд бүтэн мөр эзэлж
          доош шилжинэ (өмнө нь 170px хатуу байсан тул хальж гардаг байв). */}
      <div
        style={{
          flex: "1 1 170px",
          minWidth: 0,
          maxWidth: "100%",
          ...deptStyle,
        }}
      >
        {/* ⚠ `autoSelectOwn` нь өмнө нь ЗӨВХӨН DepartmentNegj (хэсэг) рүү
            дамждаг байсан тул цех нь «Бүгд» хэвээр үлдэж, prop-ийн нэр нь
            хийж буй зүйлтэйгээ таарахгүй байв. Одоо хоюуланд нь дамжина. */}
        <DepartmentTseh
          disabled={disabled}
          autoSelectOwn={
            autoSelectDept === undefined ? autoSelectOwn : autoSelectDept
          }
          value={deptCode || undefined}
          onChange={(code, parentId, name) => {
            setDeptCleared(!code);
            onDeptChange?.(code || "", parentId || null, name || "");
            /* ⚠ ХЭСГИЙГ ХАМТ ХООСРУУЛНА (2026-10-05): хэсгийн утга нь
               ХУУДСАНД хадгалагддаг тул доорх `key`-ээр дахин угсрах нь
               түүнийг цэвэрлэдэггүй — цехийг «Бүгд» болгосон ч хуучин
               хэсгээр шүүлт чимээгүй үлдэж байв. Хэсэг нь ЗӨВХӨН нэг
               цехэд харьяалагддаг тул цех солигдвол үргэлж хүчингүй. */
            if (sectionCode) onSectionChange?.("", "");
          }}
        />
      </div>
      {/* Хэсэг — сонгосон цехийн доторх */}
      <div
        style={{
          flex: "1 1 150px",
          minWidth: 0,
          maxWidth: "100%",
          ...sectionStyle,
        }}
      >
        <DepartmentNegj
          disabled={disabledSection === undefined ? disabled : disabledSection}
          // Цех солигдоход бүрэн дахин угсрана (сонгогдсон хэсэг үлдэхгүй)
          key={`${deptCode || "x"}-${deptParentId || "no-dept"}`}
          value={sectionCode || undefined}
          paranetid={deptParentId}
          // Кодын бүтэц: цех 2 орон · хэлтэс 4 орон · хэсэг нь угтвартай.
          // parentid зарим суулгацад хоосон ирдэг тул код нь найдвартай холбоос.
          parentCode={deptCode}
          // Цехийг хоосолсны дараа өөрийн хэсгийг дахин сонгохгүй
          autoSelectOwn={deptCleared ? false : sectionAuto}
          truncateLength={truncateLength}
          onChange={(code, name) => onSectionChange?.(code || "", name || "")}
        />
      </div>
    </>
  );
}
